// Single source of truth for order charges shown in cart and checkout.
// Shipping is priced by zone: how far the delivery address is from our
// dispatch point. Edit the rates below to match the ST Courier rate card.

export const COURIER_NAME = "ST Courier";
export const FREE_SHIPPING_THRESHOLD = 999;
export const GST_RATE = 0.05; // 5% GST for textiles/fabrics

// Where orders are dispatched from.
export const ORIGIN_STATE = "Tamil Nadu";
export const ORIGIN_CITY = "Chennai";

export const SHIPPING_ZONES = {
  local:   { label: "Within city",       fee: 40,  eta: "1–2 days" },
  state:   { label: "Within Tamil Nadu", fee: 49,  eta: "2–3 days" },
  south:   { label: "South India",       fee: 69,  eta: "3–5 days" },
  rest:    { label: "Rest of India",     fee: 89,  eta: "4–7 days" },
  special: { label: "North-East & J&K",  fee: 129, eta: "6–10 days" },
};

const SOUTH_STATES = ["kerala", "karnataka", "andhra pradesh", "telangana", "puducherry", "pondicherry"];
const SPECIAL_STATES = [
  "arunachal pradesh", "assam", "manipur", "meghalaya", "mizoram", "nagaland",
  "sikkim", "tripura", "jammu and kashmir", "jammu & kashmir", "ladakh",
  "andaman and nicobar islands", "lakshadweep",
];

const norm = (s) => (s || "").trim().toLowerCase();

// Returns the zone key for a delivery address, or null if the state is unknown.
export const getShippingZone = ({ state, city } = {}) => {
  const st = norm(state);
  if (!st) return null;
  if (st === norm(ORIGIN_STATE)) {
    return norm(city) === norm(ORIGIN_CITY) ? "local" : "state";
  }
  if (SOUTH_STATES.includes(st)) return "south";
  if (SPECIAL_STATES.includes(st)) return "special";
  return "rest";
};

// amount is the post-discount item total; GST applies on items + shipping.
// Without a known location, shipping is left out and `pending` is true
// (unless the order already qualifies for free shipping).
export const getOrderCharges = (amount, location) => {
  const zone = getShippingZone(location);
  const free = amount >= FREE_SHIPPING_THRESHOLD;
  const pending = !free && !zone;
  const shipping = free || !zone || amount <= 0 ? 0 : SHIPPING_ZONES[zone].fee;
  const gst = Number(((amount + shipping) * GST_RATE).toFixed(2));
  const total = Number((amount + shipping + gst).toFixed(2));
  return { shipping, gst, total, zone, pending };
};
